import PaperIcon from '@/common/assets/icons/paperIcon.svg?react';
import SmallCarIcon from '@/common/assets/icons/smallCarIcon.svg?react';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import MainLayout from '@/common/components/layouts/MainLayout';
import { FileRoleTypeProps } from '@/common/types/ApiResponseTypes.type';
import SwitchTab from '@/modules/adjusterReportModules/IncidentParticipants/components/common/SwitchTab';
import ShowInitialVisitAttachedVehicleImagesTab from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/initialVisit/showAccidentAttachment/ShowInitialVisitAttachedVehicleImagesTab';
import ShowInitialVisitDocumentImagesTab from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/initialVisit/showAccidentAttachment/ShowInitialVisitDocumentImagesTab';

import { useState } from 'react';
import { Box } from 'styled-system/jsx';

export default ({ userType }: FileRoleTypeProps) => {
  return (
    <MainLayout
      title=" بیمه گذار / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <ShowAdditionalImages userType={userType} />
    </MainLayout>
  );
};

const ShowAdditionalImages = ({ userType }: FileRoleTypeProps) => {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <Box mt="5.5rem">
      <TitleDescription>تصاویر الحاقی</TitleDescription>
      <Box mt="24px">
        <SwitchTab
          activeTab={1}
          tabs={tabs}
          getActiveTab={(activeTab: number) => setActiveTab(activeTab)}
        />
        {activeTab === 1 ? (
          <ShowInitialVisitAttachedVehicleImagesTab userType={userType} />
        ) : null}
        {activeTab === 2 ? (
          <ShowInitialVisitDocumentImagesTab userType={userType} />
        ) : null}
      </Box>
    </Box>
  );
};

const tabs = [
  {
    title: 'تصاویر وسیله‌نقلیه',
    activeTabIndex: 1,
    icon: <SmallCarIcon stroke={'currentColor'} />,
  },
  {
    title: 'تصاویر مدارک',
    activeTabIndex: 2,
    icon: <PaperIcon stroke={'currentColor'} />,
  },
];
